(function () {
  'use strict';
  const selector = 'form[data-quick-add-minimum]:not([data-kor-moq-enabled])';
  const warningAnimations = new WeakMap();

  function sync(form) {
    const input = form.querySelector('input[name="quantity"]');
    if (!input) return false;
    const minimum = Number(form.dataset.quickAddMinimum) || 1;
    input.min = '1';
    input.step = '1';
    const quantity = Number(input.value);
    const invalid = !Number.isInteger(quantity) || quantity < minimum;
    const minus = form.querySelector('.btn-quantity.minus');
    if (minus) minus.setAttribute('aria-disabled', String(quantity <= 1));
    let message = form.querySelector('[data-quick-add-minimum-error]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.quickAddMinimumError = '';
      message.setAttribute('role', 'alert');
      message.hidden = true;
      // Match the existing Yuko product-page custom message, not theme red text.
      message.style.cssText = 'margin:10px 0 0;font-weight:600;background-color:#ff75b1 !important;color:#4A4A4A !important;font-size:14px;text-align:left;padding:8px 12px;border-radius:4px;font-family:inherit;box-sizing:border-box;';
      message.textContent = 'You must select at least ' + minimum + ' products';
      form.appendChild(message);
    }
    const becameInvalid = invalid && message.hidden;
    message.hidden = !invalid;
    const button = form.querySelector('[name="add"]');
    if (button) {
      if (invalid) {
        if (!button.disabled) {
          button.dataset.quickAddMinimumBlocked = 'true';
          button.disabled = true;
        }
        if (!button.dataset.quickAddMinimumStyle) {
          button.dataset.quickAddMinimumStyle = JSON.stringify(
            ['opacity', 'cursor'].map(name =>
              [name, button.style.getPropertyValue(name), button.style.getPropertyPriority(name)]));
        }
        // Yuko dims the original button; do not stack a light grey fill on top.
        button.style.setProperty('opacity', '0.65', 'important');
        button.style.setProperty('cursor', 'not-allowed', 'important');
        if (becameInvalid && button.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          warningAnimations.get(button)?.cancel();
          warningAnimations.set(button, button.animate([
            {transform: 'translateY(0)', offset: 0},
            {transform: 'translateY(-6px)', offset: 0.3},
            {transform: 'translateY(0)', offset: 0.55},
            {transform: 'translateY(-3px)', offset: 0.75},
            {transform: 'translateY(0)', offset: 1}
          ], {duration: 420, easing: 'ease-out'}));
        }
      } else {
        warningAnimations.get(button)?.cancel();
        warningAnimations.delete(button);
        if (button.dataset.quickAddMinimumStyle) {
          JSON.parse(button.dataset.quickAddMinimumStyle).forEach(([name, value, priority]) => {
            if (value) button.style.setProperty(name, value, priority);
            else button.style.removeProperty(name);
          });
          delete button.dataset.quickAddMinimumStyle;
        }
        if (button.dataset.quickAddMinimumBlocked) {
          const variant = form.querySelector('[name="id"]');
          const policy = window['quick_shop_policy_array_' + input.dataset.product];
          const picker = form.closest('.quickshop')?.querySelector('variant-quick-shop-radios, variant-quick-shop-selects');
          const soldOut = picker?.currentVariant?.available === false ||
            (policy && variant && policy[variant.value] === 'deny' && Number(input.dataset.inventoryQuantity) === 0);
          if (!soldOut) button.disabled = false;
          delete button.dataset.quickAddMinimumBlocked;
        }
      }
    }
    return !invalid;
  }

  function validate(form, event) {
    const valid = sync(form);
    const input = form.querySelector('input[name="quantity"]');
    const variant = form.querySelector('[name="id"]');
    const policy = window['quick_shop_policy_array_' + input.dataset.product];
    const stock = Number(input.dataset.inventoryQuantity);
    const exceedsStock = policy && variant && policy[variant.value] === 'deny' &&
      Number.isFinite(stock) && Number(input.value) > stock;
    if (!valid || exceedsStock) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.setCustomValidity(exceedsStock ? 'Not enough stock for this quantity.' :
        'You must select at least ' + form.dataset.quickAddMinimum + ' products');
      input.reportValidity();
      input.setCustomValidity('');
      return false;
    }
    return true;
  }

  // Ella delegates add-to-cart clicks; intercept before it serializes the form.
  document.addEventListener('click', function (event) {
    const target = event.target.closest && event.target.closest('.btn-quantity, [name="add"]');
    const form = target && target.closest(selector);
    if (!form) return;
    if (target.matches('[name="add"]')) {
      validate(form, event);
      return;
    }
    const input = form.querySelector('input[name="quantity"]');
    const value = Number(input.value);
    event.preventDefault();
    event.stopImmediatePropagation();
    let next = Math.max(1, (Number.isInteger(value) ? value : 1) + (target.matches('.minus') ? -1 : 1));
    const variant = form.querySelector('[name="id"]');
    const policy = window['quick_shop_policy_array_' + input.dataset.product];
    const stock = Number(input.dataset.inventoryQuantity);
    if (policy && variant && policy[variant.value] === 'deny' && stock > 0) next = Math.min(next, stock);
    input.value = String(next);
    input.dispatchEvent(new Event('change', {bubbles: true}));
    sync(form);
  }, true);

  document.addEventListener('change', function (event) {
    const form = event.target.closest && event.target.closest(selector);
    if (!form) return;
    if (event.target.matches('[name="quantity"]')) sync(form);
    // Variant handlers may clamp to stock after this capture listener runs.
    queueMicrotask(function () { if (form.isConnected) sync(form); });
  }, true);
  document.addEventListener('input', function (event) {
    const form = event.target.closest && event.target.closest(selector);
    if (form && event.target.matches('[name="quantity"]')) sync(form);
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches(selector)) validate(event.target, event);
  }, true);
  // Popups arrive over Ajax; also recheck when Ella updates variant stock/buttons.
  function refresh() { document.querySelectorAll(selector).forEach(sync); }
  new MutationObserver(refresh).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['disabled', 'data-inventory-quantity']
  });
  refresh();
})();
